var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Accordion, AccordionSummary, Box, Grid, Typography } from '@mui/material';
import { t } from "i18next";
import { memo, useEffect, useState } from 'react';
import { getJobCardSummaryByKey } from '../../../api/url';
import { CheckCircleIcon, closeCircleIconBold } from '../../../assets/images';
import { MuiStack } from '../../../components';
import { MuiCheckBox } from '../../../components/atoms/checkBox';
import { getByIdAPI } from '../../../redux/crudSlice';
import { useAppDispatch } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
var CustomExpandIcon = function () {
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            '.Mui-expanded & > .collapsIconWrapper': {
                display: 'none'
            },
            '.expandIconWrapper': {
                display: 'none'
            },
            '.Mui-expanded & > .expandIconWrapper': {
                display: 'block'
            }
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "expandIconWrapper"
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "check",
        style: {
            transform: 'scale(-1)'
        },
        src: CheckCircleIcon
    })), /*#__PURE__*/ React.createElement("div", {
        className: "collapsIconWrapper"
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "close",
        src: closeCircleIconBold
    })));
};
var StandaredJobsList = function (props) {
    var id = props.id, callApIStatus = props.callApIStatus;
    var dispatch = useAppDispatch();
    var _a = useState([]), list = _a[0], setList = _a[1];
    useEffect(function () {
        if (callApIStatus) {
            getList();
        }
    }, [callApIStatus]);
    var getList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, requestBody, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        JobCardId: id,
                        Key: "STANDARD_JOBS"
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getJobCardSummaryByKey,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    setList(result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.data) === null || _result$payload === void 0 ? void 0 : _result$payload.Jobs);
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement("div", null, list.length > 0 ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, list === null || list === void 0 ? void 0 : list.map(function (item, index) {
        var _item$ChildSystemName;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            key: index,
            sx: {
                "& .Mui-expanded": {
                    transform: "none",
                    backgroundColor: "#EFF2F5"
                }
            }
        }, /*#__PURE__*/ React.createElement(Accordion, {
            id: "pmParts-accordian",
            style: {
                width: '100%',
                boxShadow: 'none',
                borderRadius: '8px'
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary
        //   expandIcon={<CustomExpandIcon  />}
        , {
            "aria-controls": "panel1a-content",
            id: "panel1a-header"
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center',
            justifyContent: 'space-between',
            width: "100%",
            spacing: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'start',
            width: '95%'
        }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
            id: "standard-job-service-type-checkbox",
            sx: {
                "& .MuiCheckbox-root": {
                    paddingY: 0
                }
            },
            disabled: true,
            checkBoxValue: true
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-part-name",
            variant: "h3"
        }, item === null || item === void 0 ? void 0 : item.ChildName), /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-part-code",
            variant: "h6",
            color: "secondary"
        }, "#".concat(item === null || item === void 0 ? void 0 : item.ChildCode)))), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                backgroundColor: "#EEF6FF",
                padding: "3px 8px",
                borderRadius: "12px",
                border: '1px solid #AFD5FF',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-system-name",
            sx: {
                color: systemColor === null || systemColor === void 0 ? void 0 : systemColor.primary
            },
            variant: "h5"
        }, item === null || item === void 0 || (_item$ChildSystemName = item.ChildSystemName) === null || _item$ChildSystemName === void 0 ? void 0 : _item$ChildSystemName.substring(0, 1)))))));
    })) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        paddingBottom: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "standard-job-no-data",
        variant: "h2"
    }, t("No Data Found"), "..!!"))));
};
export default /*#__PURE__*/ memo(StandaredJobsList);
